import { connectedStore } from '../../store';
import setResponsiveClassAction from '../actions/set-responsive-class';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const setResponsiveClass = ({ elementId, className, value, breakpoint, options }) => {
  const store = connectedStore.get();
  store.dispatch(setResponsiveClassAction({ elementId, className, value, breakpoint, options }));
};

setResponsiveClass[USED_ACTION_CREATOR] = setResponsiveClassAction;

export default setResponsiveClass;
